import { api, AUTH_URL } from './client';

/**
 * List all API keys for the current user
 */
export async function listAPIKeys(options = {}) {
  return api.get(`${AUTH_URL}/api/v1/api-keys`, options);
}

/**
 * Get a specific API key by ID
 */
export async function getAPIKey(keyId, options = {}) {
  return api.get(`${AUTH_URL}/api/v1/api-keys/${keyId}`, options);
}

/**
 * Create a new API key for a tenant
 */
export async function createAPIKey(data, options = {}) {
  return api.post(`${AUTH_URL}/api/v1/api-keys`, data, options);
}

/**
 * Revoke an API key
 */
export async function revokeAPIKey(keyId, options = {}) {
  return api.delete(`${AUTH_URL}/api/v1/api-keys/${keyId}`, options);
}

/**
 * Rotate an API key (creates new key, old key valid for 24h)
 */
export async function rotateAPIKey(keyId, options = {}) {
  return api.post(`${AUTH_URL}/api/v1/api-keys/${keyId}/rotate`, {}, options);
}

/**
 * List all API keys for a specific tenant (admin only)
 */
export async function listTenantAPIKeys(tenantId, options = {}) {
  return api.get(`${AUTH_URL}/api/v1/tenants/${tenantId}/api-keys`, options);
}
